const grid = document.querySelector(".m51");

if (grid) {
	const iframes = grid.querySelectorAll(".m51__post > iframe");

	iframes.forEach(iframe => {
		iframe.onload = () => {
			const width = iframe.width;
			const height = iframe.height;
			const src = iframe.src;

			if (width && height) {
				iframe.style.aspectRatio = `${width}/${height}`;
				iframe.style.width = "100%";
				iframe.style.height = "auto";
				if (src.includes("post.php")) {
					if (src.includes("show_text=true")) {
						iframe.style.maxHeight = Number(height) + 1 + "px";
					} else {
						iframe.style.maxHeight = height + "px";
					}
				}
				iframe.width = "";
				iframe.height = "";
			}
		};
	});

	let macy = Macy({
		container: ".m51__container",
		margin: 16,
		columns: 5,
		breakAt: {
			1500: 4,
			1100: 3,
			800: 2,
			530: 1,
		},
	});

	const interval = setInterval(() => {
		macy.recalculate(true);
	}, 1000);

	setTimeout(() => {
		clearInterval(interval);
	}, 10000);

	let timeout;

	window.addEventListener("resize", function () {
		clearTimeout(timeout);

		timeout = setTimeout(() => {
			macy.recalculate(true);
		}, 500);
	});
}
